import { NgModule } from '@angular/core';
import { DragPositionDirective } from './drag-position.directive';
import { DragSizeAndPositionDirective } from './drag-size-and-position.directive';
import { DragSizeDirective } from './drag-size.directive';
import { DragItemDirective } from './drag-item.directive';
import { HoverPreviewerDirective } from './hover-previewer.directive';

/** 模板編輯功能模組 */
@NgModule({
  declarations: [
    DragPositionDirective,
    DragSizeDirective,
    DragSizeAndPositionDirective,
    DragItemDirective,
    HoverPreviewerDirective,
  ],
  imports: [
  ],
  exports: [
    DragPositionDirective,
    DragSizeDirective,
    DragSizeAndPositionDirective,
    DragItemDirective,
    HoverPreviewerDirective,
  ]
})
export class ViewEditorModule { }
